
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpInputDisclaimerGroupComponent } from './cp-inputdisclaimergroup.component';
import { PoModule } from '@po-ui/ng-components';

@NgModule({
  declarations: [CpInputDisclaimerGroupComponent],
  exports: [CpInputDisclaimerGroupComponent],
  imports: [
    CommonModule,
    PoModule
  ]
})

export class InputDisclaimerGroupModule {}

